export default __webpack_public_path__ + "static/B0151-8242bd67bfe8e174916912b5bea5f0ae.png";